import { DownloadButton, ViewFileButton } from '@/components/Elements/Button'
import { getFileExtension } from '@/utils/fileHelper'
import { getWorkInstructionHistory } from '../../tabs/PRTab/VendorSelectionSubTab/PRSubmission'
import { hideModal } from '@/stores/ui/modalSlice'
import {
  Badge,
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { PRHistoryType } from '@eapproval/offer-shared'
import moment from 'moment'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

const getHistoryTypeBadgeColor = (type) => {
  switch (type) {
    case PRHistoryType.WORK_INSTRUCTION_ISSUED:
      return 'blue'
    case PRHistoryType.WORK_INSTRUCTION_ACCEPTED:
      return 'green'
    // Still waiting on the vendor, so neither issued nor done.
    case PRHistoryType.WORK_INSTRUCTION_REMINDER_SENT:
      return 'orange'
    default:
      return 'gray'
  }
}

const formatHistoryDate = (value) => {
  if (!value) {
    return '(-)'
  }

  const formatted = moment(value).format('DD-MMM-YYYY HH:mm')
  return formatted === 'Invalid date' ? '(-)' : formatted
}

const WorkInstructionHistoryModal = ({ history = [] }) => {
  const dispatch = useDispatch()

  const workInstructionHistory = useMemo(() => getWorkInstructionHistory(history), [history])

  const closeModal = () => {
    dispatch(hideModal())
  }

  return (
    <Modal isOpen={true} onClose={closeModal} size="xl" scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent maxW={'90%'}>
        <ModalHeader>Work Instruction – History &amp; Documents</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {workInstructionHistory.length === 0 ? (
            <Text color="gray.600" py="4">
              No work instruction activity yet.
            </Text>
          ) : (
            <TableContainer>
              <Table variant="simple" size="md">
                <Thead>
                  <Tr>
                    <Th width="180px">Date</Th>
                    <Th width="200px">Type</Th>
                    <Th>Description</Th>
                    <Th width="280px">Documents</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {workInstructionHistory.map((entry, index) => {
                    const files = Array.isArray(entry?.files) ? entry.files : []

                    return (
                      <Tr key={entry?._id || `${entry?.type}-${entry?.date}-${index}`}>
                        <Td whiteSpace="nowrap" verticalAlign="top">
                          {formatHistoryDate(entry?.date)}
                        </Td>
                        <Td verticalAlign="top">
                          <Badge colorScheme={getHistoryTypeBadgeColor(entry?.type)} fontSize="sm">
                            {entry?.type}
                          </Badge>
                        </Td>
                        <Td whiteSpace="normal" verticalAlign="top">
                          {entry?.description || '(-)'}
                        </Td>
                        <Td verticalAlign="top">
                          {files.length === 0 ? (
                            <Text color="gray.500">(-)</Text>
                          ) : (
                            <Flex gap="2" flexWrap="wrap">
                              {files.map((file, fileIndex) => {
                                const fileId = file?._id || file
                                const fileName = file?.originalFileName ?? `work_instruction_${fileIndex + 1}.pdf`

                                return (
                                  <HStack key={fileId || fileIndex} spacing="2">
                                    <DownloadButton fileId={fileId} fileName={fileName} displayText={fileName} />
                                    {getFileExtension(fileName) === 'pdf' && (
                                      <ViewFileButton fileId={fileId} displayText="Preview" />
                                    )}
                                  </HStack>
                                )
                              })}
                            </Flex>
                          )}
                        </Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          )}
        </ModalBody>
        <ModalFooter>
          <HStack>
            <Button colorScheme="gray" onClick={closeModal}>
              Close
            </Button>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default WorkInstructionHistoryModal
